const config = {
  mbAudioItemData: [
    {
      maskConfig: {
        click: { src: 'games/page004_game1/audio/click.mp3' },
        src: 'games/page004_game1/img/folia.png',
        cssStyle: {
          'margin-left': '-331px',
          'margin-top': '-130px',
        },
      },
      id: 'a01',
      src: 'games/page004_game1/audio/6_bear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page004_game1/img/audioOn.png', iconOff: 'games/page004_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 130,
        x: 306,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page004_game1/audio/click.mp3' },
        src: 'games/page004_game1/img/folia.png',
        cssStyle: {
          'margin-left': '-331px',
          'margin-top': '-130px',
        },
      },
      id: 'a02',
      src: 'games/page004_game1/audio/7_mole.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page004_game1/img/audioOn.png', iconOff: 'games/page004_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 130,
        x: 306,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      maskConfig: {
        click: { src: 'games/page004_game1/audio/click.mp3' },
        src: 'games/page004_game1/img/folia.png',
        cssStyle: {
          'margin-left': '-331px',
          'margin-top': '-130px',
        },
      },
      id: 'a03',
      src: 'games/page004_game1/audio/5_rabbit.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page004_game1/img/audioOn.png', iconOff: 'games/page004_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 130,
        x: 306,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
  ],
  mainImage: {
    src: 'games/page004_game1/img/bcg.webp',
  },

  multiconnect: false,
  globalItemsConfig: {
    hookPoint: {
      rad: 0,
    },
  },
  dontCheckIncorrectLines: false,

  // linesStyle: {
  //   colors: {
  //     bad: 'red',
  //     good: 'red',
  //     neutral: 'red',
  //   },
  //   size: 5,
  // },
  rules: [
    { connectId: 1, connectedWith: 4 },
    { connectId: 2, connectedWith: 5 },
    { connectId: 3, connectedWith: 6 },
  ],

  autoCheck: true,
  numberOfGoodLines: 3,
  sounds: [{ src: 'games/page004_game1/audio/click.mp3', id: 'endConnect' }],
  groups: [
    {
      name: 'left',
      items: [
        {
          audio: 'a01',
          connectId: 1,
          image: { src: 'games/page004_game1/img/bear.png' },
          imageStyle: { position: 'absolute', width: '307px', height: '307px' },
          pos: {
            x: 276,
            y: 731,
            width: 307,
            height: 307,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['top'],
          linesStyle: { colors: { neutral: '#ff0000' } },
        },
        {
          audio: 'a02',
          connectId: 2,
          image: { src: 'games/page004_game1/img/mole.png' },
          imageStyle: { position: 'absolute', width: '307px', height: '307px' },
          pos: {
            x: 778,
            y: 731,
            width: 307,
            height: 307,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['top'],
          linesStyle: { colors: { neutral: '#ff0000' } },
        },
        {
          audio: 'a03',
          connectId: 3,
          image: { src: 'games/page004_game1/img/rabbit.png' },
          imageStyle: { position: 'absolute', width: '307px', height: '307px' },
          pos: {
            x: 1280,
            y: 731,
            width: 307,
            height: 307,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['top'],
          linesStyle: { colors: { neutral: '#ff0000' } },
        },
      ],
    },
    {
      name: 'right',
      disableShuffle: true,
      items: [
        {
          connectId: 4,
          image: { src: 'games/page004_game1/img/tom.png' },
          imageStyle: { position: 'absolute', width: '318px', height: '386px' },
          pos: {
            x: 102,
            y: 144,
            width: 318,
            height: 386,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['bottom'],
          linesStyle: { colors: { neutral: '#ff0000' } },
        },
        {
          connectId: 5,
          image: { src: 'games/page004_game1/img/lisa.png' },
          imageStyle: { position: 'absolute', width: '321px', height: '395px' },
          pos: {
            x: 782,
            y: 135,
            width: 321,
            height: 395,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['bottom'],
          linesStyle: { colors: { neutral: '#ff0000' } },
        },
        {
          connectId: 6,
          image: { src: 'games/page004_game1/img/dusty.png' },
          imageStyle: { position: 'absolute', width: '343px', height: '417px' },
          pos: {
            x: 1464,
            y: 113,
            width: 343,
            height: 417,
          },
          cssStyle: { 'background-color': 'rgba(255, 255, 255, 0.01)' },
          namedHooks: ['bottom'],
          linesStyle: { colors: { neutral: '#ff0000' } },
        },
      ],
    },
  ],
};
export default config;
